// src/CloseSquareIcon.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var CloseSquareIcon = ({ ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "17",
    height: "17",
    viewBox: "0 0 17 17",
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.75371 10.8013C6.60171 10.8013 6.44971 10.7435 6.33412 10.6271C6.10217 10.3952 6.10217 10.0199 6.33412 9.78795L10.1278 5.99428C10.3597 5.76232 10.735 5.76232 10.967 5.99428C11.1989 6.22624 11.1989 6.60149 10.967 6.83345L7.17329 10.6271C7.05771 10.7435 6.90571 10.8013 6.75371 10.8013Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.5496 10.8033C10.3976 10.8033 10.2456 10.7455 10.13 10.6291L6.33315 6.83149C6.10119 6.59954 6.10119 6.22429 6.33315 5.99233C6.5659 5.76037 6.94115 5.76037 7.17232 5.99233L10.9691 9.78995C11.2011 10.0219 11.2011 10.3972 10.9691 10.6291C10.8536 10.7455 10.7008 10.8033 10.5496 10.8033Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.22014 1.58887C3.21723 1.58887 1.92285 2.96083 1.92285 5.08487V11.5512C1.92285 13.6752 3.21723 15.0472 5.22014 15.0472H12.0823C14.086 15.0472 15.3812 13.6752 15.3812 11.5512V5.08487C15.3812 2.96083 14.086 1.58887 12.0831 1.58887H5.22014ZM12.0823 16.2347H5.22014C2.53718 16.2347 0.735352 14.3521 0.735352 11.5512V5.08487C0.735352 2.28395 2.53718 0.401367 5.22014 0.401367H12.0831C14.7661 0.401367 16.5687 2.28395 16.5687 5.08487V11.5512C16.5687 14.3521 14.7661 16.2347 12.0823 16.2347Z",
          fill: "currentColor"
        }
      )
    ]
  }
);
var CloseSquareIcon_default = CloseSquareIcon;

export {
  CloseSquareIcon_default
};
